export default (path) => {
  return path.toLowerCase().split('.').pop();
};
